var map = {
	"./avatar-diego-base-full.png": 63469,
	"./avatar-diego-fall-full.png": 3797,
	"./avatar-diego-spring-full.png": 6681,
	"./avatar-diego-summer-full.png": 32609,
	"./avatar-diego-travel-full.png": 55184,
	"./avatar-diego-winter-full.png": 51593
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 47492;